/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useContacts from '../Hooks/useContacts';
import ContactForm from './ContactForm';
import ListContacts from './ListContacts';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { Actions, PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { getProfilePics } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getProfilePicUrl } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import Schedule from '../Schedule/Schedule';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import useUserHubs from '../Hooks/useUserHubs';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import EditLinkedAccountModal from './LinkAccount/EditLinkedAccount';

export const Contacts = (props) => {
  const trans = useSelector(translator);
  const resourceMap = useSelector(getProfilePics());
  const {
    parentBread,
    hubRecord,
    openSubMenu,
    handleTabChange,
    activeKey,
    userHubCall = false,
    userHubsData,
    principalRecord = {},
  } = props;
  const mHubRecord = {
    ...hubRecord,
    profilePic64: getProfilePicUrl(hubRecord?.useruuid, resourceMap, PhotoResolution.R64),
  };

  const userApi = useSelector((state) => state.apis.userApi);

  const hubUseruuid = hubRecord?.useruuid;
  const {
    data: contacts = [],
    isFetching: fetchingContacts,
    refetch: fetchContacts,
  } = useContacts({
    useruuid: hubUseruuid,
  });
  const currentUser = useSelector(getCurrentUser);
  const useruuid = useMemo(() => currentUser.useruuid, [currentUser]);
  const { refetch: fetchUserHubs } = useUserHubs({
    useruuid,
    refetchOnMount: false,
  });
  const mContacts = useMemo(
    () =>
      contacts.map((contact) => ({
        ...contact,
        profilePic64: getProfilePicUrl(contact.useruuid, resourceMap, PhotoResolution.R64),
      })),
    [contacts]
  );

  const [action, setAction] = useState(null);
  const [record, setRecord] = useState(null);
  const [showHeader, setShowHeader] = useState(false);
  const [showEditLinkedAccountModal, setShowEditLinkedAccountModal] = useState(false);
  const [editLinkedRecord, setEditLinkedRecord] = useState(null);

  const onActionClick =
    (action, record, refresh = false) =>
    () => {
      if (action === Actions.editLinkedAccount) {
        setShowEditLinkedAccountModal(true);
        setEditLinkedRecord(record);
      } else {
        setAction(action);
        setRecord(record);
      }
      setShowHeader(true);
      refresh && fetchContacts();
    };

  const header = (parentBread ?? []).concat({
    label: trans('CONTACTS'),
    onClick: onActionClick(null, null),
  });

  const onRemove = (useruuid) => {
    const errorCallback = (error) => {
      // message.error("Error removing contact!");
      console.error('Error removing contact', error);
    };
    const successCallback = (data) => {
      // message.success("Contact removed!");
      // if (contacts.length === 1) {
      //   props?.setIsStaffAssigned(false);
      // }
      const isSelfRemoved = useruuid === currentUser?.useruuid;
      if (currentUser?.permission_level != 'Staff Admin' && isSelfRemoved) {
        props?.onActionClick(null, null, true, true)();
        return null;
      }
      fetchContacts();
      if (hubRecord) {
        fetchUserHubs();
      }
    };
    try {
      userApi.removeContactFromUser(
        hubUseruuid,
        { useruuid },
        apiCallback({
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  return !action ? (
    <>
      <ListContacts
        header={header}
        hubRecord={mHubRecord}
        contacts={mContacts}
        fetchingContacts={fetchingContacts}
        onActionClick={onActionClick}
        onRemove={onRemove}
        openSubMenu={openSubMenu}
        userHubsData={userHubsData}
      />
      {showEditLinkedAccountModal && editLinkedRecord && (
        <EditLinkedAccountModal
          action={Actions.editLinkedAccount}
          isEditLinkAccountModalOpen={showEditLinkedAccountModal}
          isEditLinkAccountModalCancel={() => {
            setShowEditLinkedAccountModal(false);
            setEditLinkedRecord(null);
          }}
          hubRecord={hubRecord}
          initialFormData={{
            sourcerelationship: editLinkedRecord?.sourcerelationship ?? '',
            targetrelationship: editLinkedRecord?.targetrelationship ?? '',
          }}
          selectedStaff={editLinkedRecord}
          onActionComplete={() => {
            setShowEditLinkedAccountModal(false);
            setEditLinkedRecord(null);
            fetchContacts();
          }}
          onActionClick={onActionClick}
        />
      )}
    </>
  ) : action === Actions.inviteContact || action === Actions.editContact ? (
    <ContactForm
      parentBread={header}
      action={action}
      record={record}
      hubRecord={mHubRecord}
      onActionClick={onActionClick}
      openSubMenu={openSubMenu}
      contacts={contacts}
    />
  ) : action === Actions.addEvent ? (
    <Schedule
      parentBread={header}
      action={action}
      hubRecord={record}
      onActionClick={onActionClick}
      showHeader={showHeader}
      openSubMenu={openSubMenu}
      handleTabChange={handleTabChange}
      activeKey={null}
      contactOrStaffAction={true} //contact action callback check
      userHubCall={userHubCall}
      principalRecord={principalRecord}
    />
  ) : null;
};
